import nextDynamic from "next/dynamic";

/**
 * These are exported dynamically because of their reliance on React Portals.
 * The client logic is not available on the server side.
 */

const Card = nextDynamic(() => import("./Card"), { ssr: false });
const Cover = nextDynamic(() => import("./Cover"), { ssr: false });
const List = nextDynamic(() => import("./List"), { ssr: false });

const Modal = {
  Card,
  Cover,
  List,
};

export { Card, Cover, List };
export default Modal;
